import React from 'react';
import { TableCell as New } from './TableCell';
import { convertOldTableCellProps, OldTableCellProps } from './converter.old';

export type TableCellProps = OldTableCellProps;
export const TableCell = React.forwardRef<HTMLTableCellElement, TableCellProps>((props, ref) => (
  <New {...convertOldTableCellProps(props)} ref={ref} />
));

TableCell.displayName = 'TableCell';
